export default "__VITE_ASSET__BGo7d1a4__"